var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aabbcc",attrs:{"id":"app"}},[_c('router-view'),_vm._v(" "),_c('load'),_vm._v(" "),_c('tips'),_vm._v(" "),_c('remote-script',{attrs:{"src":"/apiChat/lib/signalr/dist/browser/signalr.min.js"}}),_vm._v(" "),_c('remote-script',{attrs:{"src":"/apiChat/js/chat.js?v=5"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-82f80f80","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 